export default "__VITE_ASSET__DblyKvHd__"